<div class="features__container">
  <div fxLayout fxLayoutAlign="space-between center" fxLayoutGap="4px" class="rule__scope-header">
    <mat-checkbox [(ngModel)]="allFeatures" (ngModelChange)="allFeaturesChanged($event)">
      <h4 fxFlex class="nomargin">Features</h4>
    </mat-checkbox>

    <span role="button" class="clickable grass-darker text__small" (click)="clearFeatures()">Clear selection</span>
  </div>

  <div *ngFor="let feature of features" class="feature">
    <div>
      <mat-checkbox
        fxFlex
        [disabled]="feature.id === 'reservations'"
        [(ngModel)]="userPermissions[feature.id]"
        (ngModelChange)="disableChildrenIfParentIsUnchecked(feature.id, $event); checkIndeterminateState()">
        <div fxLayout fxLayoutAlign="start center" fxLayoutGap="10px">
          <img
            width="20"
            class="feature__image"
            [src]="'/assets/iconography/user-management/products/' + feature.icon + '-inactive.svg'" />
          <strong fxFlex [innerHTML]="feature.label"></strong>
        </div>
      </mat-checkbox>
    </div>

    <ng-container *ngIf="feature.children && feature.children.length > 0">
      <div
        *ngFor="let child of feature.children"
        class="feature__child"
        matTooltip="{{child.tooltip}}"
        matTooltipPosition="above"
      >
        <mat-slide-toggle

          [class.pointer-events]="userPermissions[feature.id] === false"
          [(ngModel)]="userPermissions[child.id]"
          (ngModelChange)="checkIndeterminateState()">
          {{ child.label }}
        </mat-slide-toggle>
      </div>
    </ng-container>
  </div>
</div>
